interface ConditionalRendererProps {
    if?: boolean;
    renderer: Function;
}

export let ConditionalRenderer = function (props: ConditionalRendererProps) {
    if ('if' in props) {
        if (props.if) {
            return props.renderer()
        }
    }

    return null;
};
